import { Node_Type } from "./../../ricos-types";
import Caption from "../../_shared/figure/viewer-caption";
import Image from "./viewer-image";
const nodeViewRenderers = {
  [Node_Type.IMAGE]: Image,
  [Node_Type.CAPTION]: Caption
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=node-view-renderers.js.map
